module.exports = __webpack_public_path__ + "img/btn-cst-lines.1844e97d.svg";